import { IApplicationState } from '../../../types/types';
import { INotificationSettings } from '../notificationSettings/types';

export const getNotificationSettingsByBoardId = (
    state: IApplicationState,
    boardId: number
): INotificationSettings => {
    return state.model.notificationsSettings[boardId];
};
